/**
 * O prazo de uma tarefa, como FATO — não como veredito.
 *
 * "Atrasada" depende do horário de atendimento da revenda, e o contrato registra
 * isso: a derivação vive no módulo comercial, que a interface não pode importar
 * (regra r3). Chamar de atrasada uma tarefa cujo prazo caiu num sábado seria
 * errado, e a tela não tem como saber.
 *
 * Então ela diz o que sabe: quanto falta, ou quanto passou. Quem julga é quem lê,
 * com o calendário da própria loja na cabeça.
 */
export function prazoEmPalavras(
  prazoEm: string | null | undefined,
  agora = Date.now(),
): { readonly texto: string; readonly passou: boolean } | null {
  if (!prazoEm) return null;

  const instante = Date.parse(prazoEm);
  if (Number.isNaN(instante)) return null;

  const diferenca = instante - agora;
  const passou = diferenca < 0;
  const minutos = Math.floor(Math.abs(diferenca) / 60_000);

  const quanto =
    minutos < 60
      ? `${minutos} min`
      : minutos < 1440
        ? `${Math.floor(minutos / 60)} h`
        : `${Math.floor(minutos / 1440)} ${Math.floor(minutos / 1440) === 1 ? 'dia' : 'dias'}`;

  return { texto: passou ? `prazo passou há ${quanto}` : `prazo em ${quanto}`, passou };
}
